import icCloseSquare from 'assets/images/ic-close-square.svg'
import Button from 'components/commons/button'
import { Import } from 'components/commons/import/Import'
import Modal from 'components/commons/modal'
import { TABLE_DEVELOPMENT_SUMMARY_IMPORT } from 'configs/hr-metrics/configTableDevelopmentSummary'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { API_DEVELOPMENT_SUMMARY } from 'services/apiDevelopmentSummary'

export const ImportDevelopmentSummaryContainer = ({ show, onHide }) => {
    const [searchParams] = useSearchParams()
    const periodId = searchParams.get('periodId')
    const [isComplete, setIsComplete] = useState(false)

    useEffect(() => {
        if (show) setIsComplete(false)
    }, [show])

    const api = {
        fetchTemplate: {
            ...API_DEVELOPMENT_SUMMARY.DOWNLOAD_TEMPLATE,
            api: API_DEVELOPMENT_SUMMARY.DOWNLOAD_TEMPLATE.api + `/${periodId}`,
        },
        fetchValidate: {
            ...API_DEVELOPMENT_SUMMARY.FILE_VALIDATION,
            api: API_DEVELOPMENT_SUMMARY.FILE_VALIDATION.api + `/${periodId}`,
        },
        fetchImport: { ...API_DEVELOPMENT_SUMMARY.IMPORT, api: API_DEVELOPMENT_SUMMARY.IMPORT.api + `/${periodId}` },
    }

    const props = {
        title: 'Development Summary',
        columnTableView: TABLE_DEVELOPMENT_SUMMARY_IMPORT,
        api: api,
        returnTitle: 'View Development Summary',
        onHide: onHide,
        setCompleteImport: (value) => setIsComplete(value),
    }

    return (
        <Modal dialogClassName='w-[70%]' contentClassName='rounded-xl' show={show}>
            <div className={'px-6 py-3 flex flex-row items-center justify-between border-b'}>
                <p className={'font-semibold text-md'}>Import Data</p>
                <Button
                    type='outline'
                    shape='circle'
                    size='small'
                    icon={icCloseSquare}
                    onClick={() => onHide(isComplete)}
                />
            </div>
            <div className='overflow-auto'>
                <Import {...props} />
            </div>
        </Modal>
    )
}
